import { graphql } from "../__generated__/gql";

export const GET_COUNTRIES_QUERY = graphql(`
  query GetCountries {
    countries: locationCountry {
      countryId
      locationLevel
      iso3Code
      nameEn
      nameShortEn
      legacyCountryId
      inCp
      inMv
      isTrusted
      reportedServ
      reportedServRecent
      thePrefix
    }
  }
`);

export default GET_COUNTRIES_QUERY;
